import React, { useContext, useState } from "react";
import { Row, Col, Button, FormControl } from "react-bootstrap";
import ComponentContext from "../Context";

const EmailForm = () => {
  const context = useContext(ComponentContext);
  const [email, set_email] = useState("");

  const sendEmail = () => {
    if (email !== "") {
      context.ApiDriver.sendDownloadEmail(
        { email },
        data => {
          console.log(data);
          context.notification("لینک دانلود به ایمیل شما ارسال شد.", "success");
          context.modal.hide();
        },
        error => {
          for (let err in error.response.data.errors) {
            context.notification(error.response.data.errors[err], "error");
          }
        },
      );
    } else {
      context.notification("لطفا ایمیل خود را وارد نمایید.", "error");
    }
  };

  return (
    <div>
      <Col>
        <Row>
          <label>لطفا ایمیل خود را وارد نمایید.</label>
          <FormControl
            placeholder="ایمیل"
            type="email"
            onChange={e => set_email(e.target.value)}
          />
        </Row>
        <Row style={{ padding: 50 }} className="justify-content-center">
          <Button bsPrefix="custom-button" onClick={sendEmail}>
            دانلود
          </Button>
        </Row>
      </Col>
    </div>
  );
};

export default EmailForm;
